module.exports = __webpack_public_path__ + "img/FR18529.eaf5b2ee.png";